import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

/**
 * Delete confirmation modal with animations
 */
const DeleteConfirmation = React.memo(({ 
  isVisible, 
  conversation,
  onCancel, 
  onConfirm 
}) => (
  <AnimatePresence>
    {isVisible && conversation && (
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm flex items-center justify-center z-50 px-4"
      >
        <motion.div 
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="bg-slate-800 rounded-xl p-6 max-w-md w-full border border-slate-700/50 shadow-xl"
        >
          <div className="flex items-start mb-4">
            <div className="bg-red-500/20 p-3 rounded-lg mr-4">
              <AlertCircle className="w-6 h-6 text-red-400" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Delete Conversation</h3>
              <p className="text-slate-300">
                Are you sure you want to delete the conversation "{conversation.metadata?.title || 'Untitled'}"?
              </p>
              <p className="text-red-300 text-sm mt-2">
                This action cannot be undone.
              </p>
            </div>
          </div>
          <div className="flex justify-end space-x-3 mt-6">
            <button
              onClick={onCancel}
              className="px-4 py-2.5 bg-slate-700 text-white rounded-lg hover:bg-slate-600 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => onConfirm(conversation)}
              className="px-4 py-2.5 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:from-red-600 hover:to-red-700 transition-colors shadow-md"
            >
              Delete
            </button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
));

export default DeleteConfirmation;